var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"label":((_vm.$vuetify.lang.t('$vuetify.io.mVideoInput.title')) + "*"),"accept":"video/mp4,video/webm","rules":_vm.videoRules,"show-size":""},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }